import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { PRODUCT_MENU, SHADE_PAIRS, DRAPERY_PAIRS } from '../../data/productNav';

const slug = (s) => s.toLowerCase().replace(/[^a-z]+/g, '-');

export const ProductsMegaMenu = ({ onNavigate }) => (
  <div className="bg-white rounded-md shadow-lg border border-neutral-100 p-6 grid grid-cols-5 gap-6 w-[min(1100px,92vw)]" data-testid="products-mega-menu">
    {PRODUCT_MENU.map((g) => (
      <div key={g.title}>
        <Link to={g.href} onClick={onNavigate} className="block text-xs font-semibold uppercase tracking-wider text-amber-700 mb-3 hover:text-amber-900" data-testid={`mega-group-${slug(g.title)}`}>{g.title}</Link>
        {g.items.map((i) => (
          <Link key={i.href} to={i.href} onClick={onNavigate} className="block py-1.5 text-sm text-neutral-700 hover:text-amber-600 transition-colors" data-testid={`mega-link-${slug(i.name)}`}>{i.name}</Link>
        ))}
      </div>
    ))}
  </div>
);

export const ProductsMobileAccordion = () => {
  const [open, setOpen] = useState(null);
  return (
    <div className="pl-4 mt-3 flex flex-col" data-testid="products-mobile-accordion">
      {PRODUCT_MENU.map((g) => (
        <div key={g.title} className="border-b border-neutral-100">
          <button type="button" onClick={() => setOpen(open === g.title ? null : g.title)} className="w-full flex items-center justify-between py-3 text-neutral-800 font-medium" aria-expanded={open === g.title} data-testid={`mobile-group-${slug(g.title)}`}>
            {g.title}<ChevronDown className={`w-4 h-4 transition-transform ${open === g.title ? 'rotate-180' : ''}`} />
          </button>
          {open === g.title && (
            <div className="pb-3 flex flex-col gap-2">
              <Link to={g.href} className="text-sm text-amber-700" data-testid={`mobile-all-${slug(g.title)}`}>{g.title === 'More' ? 'View All' : `All ${g.title}`}</Link>
              {g.items.map((i) => <Link key={i.href} to={i.href} className="text-neutral-600" data-testid={`mobile-link-${slug(i.name)}`}>{i.name}</Link>)}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

// Landing-page table: each product with its standard and motorized versions.
export const ProductPairs = ({ kind }) => {
  const pairs = kind === 'drapery' ? DRAPERY_PAIRS : SHADE_PAIRS;
  return (
    <section className="section-padding bg-white" data-testid={`product-pairs-${kind}`}>
      <div className="container-xl">
        <span className="label-overline text-amber-700">Standard &amp; motorized</span>
        <h2 className="mt-4 mb-8">{kind === 'drapery' ? 'Every drapery style, manual or motorized' : 'Every shade type, standard or motorized'}</h2>
        <div className="divide-y divide-neutral-200 border-y border-neutral-200">
          {pairs.map((p) => (
            <div key={p.name} className="grid sm:grid-cols-[1.2fr_1fr_1fr] gap-2 sm:gap-6 py-4 items-center" data-testid={`pair-${slug(p.name)}`}>
              <span className="font-medium text-neutral-900">{p.name}</span>
              {p.std ? <Link to={p.std} className="text-sm text-neutral-700 hover:text-amber-700 underline-offset-2 hover:underline">{p.name}</Link> : <span className="text-sm text-neutral-400">Motorized only</span>}
              {p.moto ? <Link to={p.moto} className="text-sm text-amber-700 hover:text-amber-900 underline-offset-2 hover:underline">Motorized {p.name}</Link> : <span className="text-sm text-neutral-400">Manual only</span>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
